export default "__VITE_ASSET__BfjX3i7S__"